export function matchPath(path: string, matcher: string[]): boolean {
  const formatPath = path.trim().replace('/', '');
  if (!formatPath) {
    return false;
  }
  const pathRegexp = new RegExp(`${formatPath}`, 'i');
  return matcher.some((match) => pathRegexp.test(match));
}
